"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = require("react");

var _reactTable = require("react-table");

var _useResizeColumns = require("./useResizeColumns");

const useTable = function (options) {
  for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    plugins[_key - 1] = arguments[_key];
  }

  const safePlugins = (0, _react.useMemo)(() => {
    const newPlugins = [...plugins];
    const resizeColumnsPluginIndex = newPlugins.findIndex(_ref => {
      let {
        pluginName
      } = _ref;
      return pluginName === 'useResizeColumns';
    });
    const hasResizeColumnsPlugin = resizeColumnsPluginIndex !== -1;

    if (hasResizeColumnsPlugin) {
      newPlugins[resizeColumnsPluginIndex] = _useResizeColumns.useResizeColumns;
    }

    return newPlugins;
  }, [plugins]);
  return (0, _reactTable.useTable)(options, ...safePlugins);
};

var _default = useTable;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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